import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { peopleSegmentHubDownloadItems } from '../../../constants/PeopleSegment';
import DownloadResources from '../../common/page-sections/DownloadResources';

//Downloads section
export default function SectionFive() {
  const { t } = useTranslation(i18next.language);

  useEffect(() => {
    if (localStorage.getItem('i18nnextLng')?.length > 2) {
      i18next.changeLanguage('en');
    }
  }, []);

  let downloadItems = peopleSegmentHubDownloadItems.map((item) => {
    return {
      title: t(item.title),
      subtitle: t(item.subtitle),
      multipleFiles: item.multipleFiles,
      fileToDownload: item.fileToDownload
    };
  });

  return (
    <div className="ps-hub-section5">
      <Box sx={{ flexGrow: 1 }}>
        <DownloadResources listItems={downloadItems} />
      </Box>
    </div>
  );
}
